import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveImageUrl, getProductUrl } from '../../utils/urlHelper';

const ChatMessage = ({ 
  username, 
  message, 
  timestamp, 
  isOwn = false, 
  showUsername = true,
  isAnonymous = false,
  isBot = false,
  isError = false,
  metadata = null,
  storeSlug = null,
  storeLogo = null
}) => {
  const navigate = useNavigate();

  const formatTime = (ts) => {
    if (!ts) return '';
    return new Date(ts).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const parseMetadata = (m) => {
    if (!m) return null;
    if (typeof m === 'object') return m;
    try {
      return JSON.parse(m);
    } catch {
      return null;
    }
  };

  const activeMetadata = parseMetadata(metadata);
  const isProductCard = activeMetadata?.type === 'product_card' && activeMetadata?.product;

  if (isProductCard) {
    const product = activeMetadata.product;
    const productUrl = storeSlug ? getProductUrl(storeSlug, product.id) : null;
    const storeUrl = storeSlug ? `/store/${storeSlug}` : '#';
    const imageUrl = resolveImageUrl(product.image_url);
    const resolvedStoreLogo = resolveImageUrl(storeLogo || activeMetadata.store_logo);

    return (
      <div className={`chat-message product-card-msg ${isOwn ? 'own' : ''}`}>
        {showUsername && !isAnonymous && (
          <span className="message-username">{username}</span>
        )}
        <span className="message-time">{formatTime(timestamp)}</span>
        
        <div className="product-card-container">
          {/* Store Shortcut */}
          <a 
            href={storeUrl}
            className="product-card-store-link"
            title="Ir a la tienda"
            onClick={(e) => {
              e.preventDefault();
              if (storeSlug) navigate(`/store/${storeSlug}`);
            }}
          >
            {resolvedStoreLogo ? (
              <img src={resolvedStoreLogo} alt="Tienda" />
            ) : (
              <div className="store-placeholder">🏬</div>
            )}
          </a>

          {/* Product Info */}
          <a 
            href={productUrl || '#'} 
            className="product-card-content"
            onClick={(e) => {
              e.preventDefault();
              if (storeSlug && product.id) {
                navigate(`/store/${storeSlug}?product=${product.id}`, { replace: true });
              }
            }}
          >
            <div className="product-card-image">
              {imageUrl ? (
                <img src={imageUrl} alt={product.name} />
              ) : (
                <div className="product-card-placeholder">📦</div>
              )}
            </div>
            <div className="product-card-info">
              <div className="product-card-name-black">{product.name}</div>
              <div className="product-card-price-green">${Number(product.price || 0).toFixed(2)}</div>
              <div className="product-card-view-btn-blue">Ver Detalle</div>
            </div>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={`chat-message ${isOwn ? 'own' : ''} ${isAnonymous ? 'anonymous' : ''} ${isBot ? 'bot-message' : ''} ${isError ? 'error-message' : ''}`}>
      {showUsername && !isAnonymous && (
        <span className="message-username">{username}</span>
      )}
      {isAnonymous && (
        <span className="message-username">Anónimo</span>
      )}
      <span className="message-time">{formatTime(timestamp)}</span>
      <p className="message-text">{message}</p>
    </div>
  );
};

export default ChatMessage;
